<template>
  <div class="admeta">
    <span class="adkind">{{ detail.kind_label }}</span>
    <span class="adwhen">{{ detail.when }}</span>
    <span v-if="detail.brand" class="adbrand">{{ detail.brand }}</span>
  </div>
  <p v-if="detail.explain" class="adexplain">{{ detail.explain }}</p>
  <p v-if="detail.action" class="adaction">{{ detail.action }}</p>
  <div v-if="detail.tasks?.length" class="adtasks">
    <article v-for="task in detail.tasks" :key="task.id || task.title" class="adtask">
      <div class="adtrow"><strong class="adtt">{{ task.title }}</strong><span class="adtown">{{ task.owner }}</span></div>
      <p class="adtmeta">{{ task.status }} · {{ task.week }}</p>
      <p v-if="task.why" class="adtwhy">{{ task.why }}</p>
    </article>
  </div>
</template>

<script setup>
defineProps({ detail: { type: Object, required: true } });
</script>
